// Generate harmonious pastel colors
const generateHarmoniosColors = () => {
  // Base hue (0-360)
  const baseHue = Math.floor(Math.random() * 360)
  // Generate complementary hue (opposite on color wheel)
  const complementaryHue = (baseHue + 180) % 360
  // Create pastel colors with high lightness and low saturation
  const color1 = `hsl(${baseHue}, 40%, 90%)`
  const color2 = `hsl(${complementaryHue}, 40%, 92%)`
  return { primary: color1, secondary: color2 }
}
export { generateHarmoniosColors }